/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const it_course_explorer_open_filters = /** @type {(inputs: {}) => string} */ () => {
	return `Apri filtri`
};

const en_course_explorer_open_filters = /** @type {(inputs: {}) => string} */ () => {
	return `Open filters`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "it" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const course_explorer_open_filters = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.course_explorer_open_filters(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("course_explorer_open_filters", locale)
	if (locale === "it") return it_course_explorer_open_filters(inputs)
	return en_course_explorer_open_filters(inputs)
};
export { course_explorer_open_filters as "course-explorer.open-filters" }